import { z } from "zod";
import {
  MedicalCertificateDataSchema,
  MedicalCertificateContextSchema,
  MedicalCertificateExtractionSchema,
  type MedicalCertificateData,
} from "../../../document/document-types/medical-certificate";
import type { FieldMessages } from "../../../document/types";
import { createFieldMessagesSchema } from "../../../document/schema";
import { storeResponseSchema } from "../base";
import type { DocumentTypeSchemas } from "../types";

// ===== Internal schemas (not exported) =====

const fieldMessagesSchema = createFieldMessagesSchema(MedicalCertificateDataSchema);

const warnRequestSchema = z.object({
  data: MedicalCertificateDataSchema.partial(),
  context: MedicalCertificateContextSchema,
});

const validateRequestSchema = z.object({
  data: MedicalCertificateDataSchema.partial(),
  context: MedicalCertificateContextSchema,
});

// ===== Exported types (for API client) =====

/** Response type for /extract endpoint */
export type ExtractResponse = z.infer<typeof MedicalCertificateExtractionSchema>;

/** Request body type for /warn endpoint */
export type WarnRequestBody = z.infer<typeof warnRequestSchema>;

/** Response type for /warn endpoint - uses FieldMessages for proper key typing */
export type WarnResponse = FieldMessages<MedicalCertificateData>;

/** Request body type for /validate endpoint */
export type ValidateRequestBody = z.infer<typeof validateRequestSchema>;

/** Response type for /validate endpoint - uses FieldMessages for proper key typing */
export type ValidateResponse = FieldMessages<MedicalCertificateData>;

/** Response type for /store endpoint */
export type StoreResponse = z.infer<typeof storeResponseSchema>;

// ===== Exported bundle (source of truth for route registration) =====

/**
 * Bundled schemas for route factory registration
 */
export const MedicalCertificateSchemas = {
  extractResponse: MedicalCertificateExtractionSchema,
  warnRequest: warnRequestSchema,
  warnResponse: fieldMessagesSchema,
  validateRequest: validateRequestSchema,
  validateResponse: fieldMessagesSchema,
  storeResponse: storeResponseSchema,
} satisfies DocumentTypeSchemas;
